import { isMobileLayout } from '@hooks/useIsMobileLayout';
/*
 * Page flags the browser can check by itself, keyed by the reason they give. A flag with no
 * check here is decided by the server (it lists the route in unavailableRoutes).
 */
export const CLIENT_REQUIREMENT_CHECKS = {
    desktopOnly: () => !isMobileLayout(),
};
/** The first page flag on the route that a client-side check says is not met. */
export function clientUnavailableReason(config) {
    if (!config)
        return undefined;
    return Object.keys(CLIENT_REQUIREMENT_CHECKS).find(reason => {
        const check = CLIENT_REQUIREMENT_CHECKS[reason];
        return !!config[reason] && !!check && !check(config);
    });
}
